<template>
  <div id="berandalaporan">
    <section>
      <div class="card container-1056">
        <b-tabs v-model="activeTab" position="is-centered"> 
          <b-tab-item label="Unggah Excel">
            <br />
            <p>1. Pastikan File Anda xlx/xlxs</p>
            <p>
              2. Pastikan Data yang anda Import tidak terdapat isi bentuk rumus
            </p>
            <p>
              3. Sebelum Import File,pastikan data Biro anda sudah terdaftar
              disistem
            </p>
            <br />

            <b-field>
              <b-upload
                v-model="file"
                @input="readImage"
                accept=".xls,.xlsx"
                drag-drop
                v-if="upload">
                <section class="section">
                  <div class="content has-text-centered">
                    <p v-if="upload">
                      <b-icon icon="upload" size="is-medium"> </b-icon>
                    </p>
                    <p v-if="upload">
                      Choose your files here and click to upload
                    </p>
                  </div>
                </section>
              </b-upload>
            </b-field>
            <div class="tags">
              <span class="tag is-primary" v-if="preview">
                {{ file.name }}
                <button
                  class="delete is-small"
                  type="button"
                  @click="deleteDropFile()"
                ></button>
              </span>
            </div>

            <br />
            <b-button class="button is-success container-1056 mt-24" @click="postData()">
              Unggah Excel
            </b-button>
            <br />
            <br />
            <!-- SEKOLAH -->
            <div class="card-content" v-show="error_sekolah.length > 0">
              <p class="title is-5">Error Sekolah</p>
              <b-switch v-model="show.sekolah">Show Error</b-switch>
              <table style="border: 1px solid; width: 100%; margin-top: 1em" v-show="show.sekolah">
                <tr>
                  <th>No</th>
                  <th>Nama Sekolah</th>
                  <th>Pesan Error</th>
                </tr>
                <tr v-for="(error, index) in error_sekolah" :key="error.id">
                  <td class="td-column">
                    <b> {{ index + 1 }}</b>
                  </td>
                  <td class="td-column">
                    <b>{{ error.data.nama_sekolah }} </b>
                  </td>
                  <td class="td-column">
                    <div v-for="item in error.bug" :key="item">
                      <b>- {{ item }}</b>
                      <br />
                    </div>
                  </td>
                </tr>
              </table>
            </div>

            <!-- GURU -->
            <div class="card-content" v-show="error_guru.length > 0">
              <p class="title is-5">Error Guru</p>
              <b-switch v-model="show.guru">Show Error</b-switch>
              <table
                style="border: 1px solid; width: 100%; margin-top: 1em"
                v-show="show.guru">
                <tr>
                  <th>No</th>
                  <th>Nama Guru</th>
                  <th>Pesan Error</th>
                </tr>
                <tr v-for="(error, index) in error_guru" :key="error.id">
                  <td class="td-column">
                    <b> {{ index + 1 }}</b>
                  </td>
                  <td class="td-column">
                    <b>{{ error.data.nama_guru }} </b>
                  </td>
                  <td class="td-column">
                    <div v-for="item in error.bug" :key="item">
                      <b>- {{ item }}</b>
                      <br />
                    </div>
                  </td>
                </tr>
              </table>
            </div>

            <!-- PERSONIL BIRO -->
            <div class="card-content" v-show="error_personil.length > 0">
              <p class="title is-5">Error Personil Biro</p>
              <b-switch v-model="show.personil">Show Error</b-switch>
              <table
                style="border: 1px solid; width: 100%; margin-top: 1em"
                v-show="error_personil.length > 0">
                <tr>
                  <th>No</th>
                  <th>Nama Personil</th>
                  <th>Pesan Error</th>
                </tr>
                <tr v-for="(error, index) in error_personil" :key="error.id">
                  <td class="td-column">
                    <b> {{ index + 1 }}</b>
                  </td>
                  <td class="td-column">
                    <b>{{ error.data.nama_personil }} </b>
                  </td>
                  <td class="td-column">
                    <b>{{ error.bug }} </b>
                  </td>
                </tr>
              </table>
            </div>

            <!-- SISWA -->
            <div class="card-content" v-show="error_siswa.length > 0">
              <p class="title is-5">Error Siswa</p>
              <b-switch v-model="show.siswa">Show Error</b-switch>
              <table
                style="border: 1px solid; width: 100%; margin-top: 1em"
                v-show="show.siswa">
                <tr>
                  <th>No</th>
                  <th>Nama Siswa</th>
                  <th>Pesan Error</th>
                </tr>
                <tr v-for="(error, index) in error_siswa" :key="error.id">
                  <td class="td-column">
                    <b> {{ index + 1 }}</b>
                  </td>
                  <td class="td-column">
                    <b>{{ error.data.nama_siswa }} </b>
                  </td>
                  <td class="td-column">
                    <b>{{ error.bug }} </b>
                  </td>
                </tr>
              </table>
            </div>
          </b-tab-item>

          <b-tab-item label="Download Excel">
            <br/>
            <div>
              <p>Menu ini untuk download data yang berada di sistem</p>
              <p>Data yang di download berupa Excel</p>
              <p>Adapun Data yang terdapat pada excel meliputi:</p>
              <div class="font-bold">
                <p>1. Data Siswa</p>
                <p>2. Data Guru</p>
                <p>3. Data Sekolah</p>
                <p>4. Data Regu</p>
                <p>5. Data Event</p>
                <p>6. Data Personil Biro</p>
              </div>
            </div>

            <b-button
              class="button is-success container-1056 mt-64"
              @click="isComponentEksport = true"
              icon-left="file"
              >Download Excel
            </b-button>
            <b-modal
              v-model="isComponentEksport"
              has-modal-card
              trap-focus
              :destroy-on-hide="false"
              aria-role="dialog"
              aria-modal
            >
              <template #default="props">
                <modal-form-export 
                  :id_biro="detailId" 
                  @loading="handleLoading"
                  @close="props.close">
                </modal-form-export>
              </template>
            </b-modal>
          </b-tab-item>

          <b-tab-item label="Template Excel">
            <p>Menu ini untuk download template excel</p>
            <p>Sebelum unggah excel pada sistem, 
            <span class="text-bold">
              download template terlebih dahulu
            </span>
            </p>
            <b-button
              class="button is-success container-1056 mt-64"
              @click="isComponentTemplate = true"
              icon-left="file">
              Template Excel
            </b-button>
            <!-- <b-modal
              :active="isComponentTemplate"
              has-modal-card
              trap-focus
              :destroy-on-hide="false"
              aria-role="dialog"
              aria-modal
            >
              <template #default="props">
                <modal-form v-bind="file" @close="props.close"></modal-form>
              </template>
            </b-modal> -->
            <b-modal
              v-model="isComponentTemplate"
              has-modal-card
              trap-focus
              :destroy-on-hide="false"
              aria-role="dialog"
              aria-modal
            >
              <template #default="props">
                <modal-form-template 
                  @loading="handleLoading"
                  @close="props.close">
                </modal-form-template>
              </template>
            </b-modal>
          </b-tab-item>
        
        </b-tabs>
      </div>
      <div class="card container-1056 mt-64">
        <b-tabs v-model="activeTabEvent" position="is-centered">
          <b-tab-item label="Unggah Data Event">
            <br />
            <p>1. Pastikan File Anda xlx/xlxs</p>
            <p>
              2. Pastikan Data yang anda Import sesuai dengan judul di excel
            </p>
            <br />
            <b-field>
              <b-upload
                v-model="file_microteaching"
                @input="readImageMicroteaching"
                accept=".xls,.xlsx"
                drag-drop
                v-if="uploadMicroteaching"
              >
                <section class="section">
                  <div class="content has-text-centered">
                    <p v-if="uploadMicroteaching">
                      <b-icon icon="upload" size="is-medium"> </b-icon>
                    </p>
                    <p v-if="uploadMicroteaching">
                      Choose your files here and click to upload
                    </p>
                  </div>
                </section>
              </b-upload>
            </b-field>
            <div class="tags">
              <span class="tag is-primary" v-if="previewMicroteaching">
                {{ file_microteaching.name }}
                <button
                  class="delete is-small"
                  type="button"
                  @click="deleteDropFileMicroteaching()"
                ></button>
              </span>
            </div>

            <br />
            <b-button class="container-1056 button is-success" @click="postDataMicro()">
              Unggah Data Event
            </b-button>
            <br>
          </b-tab-item>
          <b-tab-item label="Template Data Event">
            <p>Menu ini untuk download template event dalam jumlah banyak</p>
            <p>Sebelum unggah data event pada sistem, 
            <span class="text-bold">
              download template terlebih dahulu
            </span>
            </p>
            <p style="margin-top: 32px"> Silahkan Unduh Excel Event Dibawah ini </p>
            <br>
            <b-button 
              class="container-1056 button is-success"
              @click="isComponentMicro = true"
              icon-left="file">
              Unduh Excel
            </b-button>
            <b-modal
              v-model="isComponentMicro"
              has-modal-card
              trap-focus
              :destroy-on-hide="false"
              aria-role="dialog"
              aria-modal
            >
              <template #default="props">
                <modal-form-micro 
                  @loading="handleLoading"
                  @close="props.close">
                </modal-form-micro>
              </template>
            </b-modal>
          </b-tab-item>
        </b-tabs>
      </div>
      <br />
    </section>
    <b-loading
      :is-full-page="true"
      :active.sync="isLoading"
      :can-cancel="false"
    >
    </b-loading>
  </div>
</template>

<script>
const ModalFormMicro = {
  props: ["id_biro"],
  template: `
    <form action="">
      <div class="modal-card" style="width: 500px">
        <header class="modal-card-head">
          <p class="modal-card-title">Download Template</p>
            <button
              type="button"
              class="delete"
              @click="$parent.close()"/>
        </header>
        <section class="modal-card-body">
          <p class="subtitle">Anda yakin download template event microteaching ?</p>
        </section>
        <footer class="modal-card-foot">
          <b-button type="button is-danger" @click="$parent.close()">Close</b-button>
          <b-button type="button is-success" @click="templateMicro()">Download</b-button>
        </footer>
      </div>
    </form>
    `,
  methods: {
     setLoading(bool){
      this.$emit('loading', bool)
    },
    closeModal(){
      this.$emit('close');
    },
    templateMicro() {
      this.setLoading(true)
      var uri = this.$apiUrl + "template/micro"
      this.$http.get(uri, {
        headers: {
          'Authorization': 'Bearer ' + this.$session.get('token'),
          'Content-Type': 'application/json'
        }
      }).then(response => {
        let link = document.createElement('a')
        link.href = response.data.value
        link.download = response.data.file_name
        link.click()
        this.setLoading(false)
        this.closeModal()
      })
      .catch(error =>{
        console.log(error)
        this.setLoading(false)
        this.closeModal()
      })
      // this.$emit("close");
      // window.open(uri);
    },
  },
};
const ModalFormExport = {
  props: ["id_biro"],
  template: `
    <form action="">
      <div class="modal-card" style="width: 500px">
        <header class="modal-card-head">
          <p class="modal-card-title">Download Data</p>
            <button
              type="button"
              class="delete"
              @click="$parent.close()"/>
        </header>
        <section class="modal-card-body">
          <p class="subtitle">Anda yakin ingin download data?</p>
        </section>
        <footer class="modal-card-foot">
          <b-button type="button" @click="$parent.close()">Close</b-button>
          <b-button type="button is-primary" @click="exportExcel()">Ya</b-button>
        </footer>
      </div>
    </form>
    `,
  methods: {
    setLoading(bool){
      this.$emit('loading', bool)
    },
    closeModal(){
      this.$emit('close');
    },
    exportExcel() {
      this.setLoading(true)
      var uri = this.$apiUrl + "export/" + this.id_biro;
      this.$http.get(uri, {
        headers: {
          'Authorization': 'Bearer ' + this.$session.get('token'),
          'Content-Type': 'application/json'
        }
      }).then(response => {
        let link = document.createElement('a')
        link.href = response.data.value
        link.download = response.data.file_name
        link.click()
        this.setLoading(false)
        this.closeModal()
      })
      .catch(error =>{
        console.log(error)
        this.setLoading(false)
        this.closeModal()
      })
      // this.$emit("close");
      // window.open(uri);
    },
  },
};

const ModalFormTemplate = {
  props: ["id_biro"],
  template: `
  <form action="">
    <div class="modal-card" style="width: 500px">
      <header class="modal-card-head">
        <p class="modal-card-title">Download Excel</p>
          <button
            type="button"
            class="delete"
            @click="$parent.close()"/>
      </header>
      <section class="modal-card-body">
        <p class="subtitle">Anda yakin download Template Excel?</p>
      </section>
      <footer class="modal-card-foot">
        <b-button type="button" @click="$parent.close()">Close</b-button>
        <b-button type="button is-primary" @click="templateExcel()">Ya</b-button>
      </footer>
    </div>
  </form>
  `,
  methods: {
    setLoading(bool){
      this.$emit('loading', bool)
    },
    closeModal(){
      this.$emit('close');
    },
    templateExcel() {
      this.setLoading(true)
      var uri = this.$apiUrl + "template";
      this.$http.get(uri, {
        headers: {
          'Authorization': 'Bearer ' + this.$session.get('token'),
          'Content-Type': 'application/json'
        }
      }).then(response => {
        let link = document.createElement('a')
        link.href = response.data.value
        link.download = response.data.file_name
        link.click()
        this.setLoading(false)
        this.closeModal()
      })
      .catch(error =>{
        console.log(error)
        this.setLoading(false)
        this.closeModal()
      })
      // this.$emit("close");
      // window.open(uri);
    },
  },
};

export default {
  components: {
    // ModalFormImport,
    ModalFormExport,
    ModalFormTemplate,
    ModalFormMicro
  },
  data() {
    return {
      activeTab: 0,
      activeTabEvent: 0,
      file: null,
      file_microteaching: null,
      checkboxGroup: [],
      biros: [],
      error_guru: [],
      error_siswa: [],
      error_sekolah: [],
      error_personil: [],
      error_micro: [],
      detailId: "",
      activeBiro: Object,
      // isComponentImport : false,
      isComponentEksport: false,
      isComponentTemplate: false,
      isComponentMicro: false,
      isLoading: false,
      upload: true,
      preview: false,
      uploadMicroteaching: true,
      previewMicroteaching: false,
      detailId: "",
      form: {
        file: {
          value: "",
          type: "",
          message: "",
        },
      },
      config: {},
      show: {
        sekolah: true,
        guru: true,
        personil: true,
        siswa: true
      },

      // form:
      //     {
      //         nama_biro:{value:'', type:'', message:''},
      //     }
    };
  },
  methods: {
    handleLoading(boolean){
      this.isLoading = boolean
    },
    getBiro() {
      var uri = this.$apiUrl + "biro";
      this.$http.get(uri, this.config).then((response) => {
        this.biros = response.data.value;
      });
    },
    getNotifikasi() {
      var uri = this.$apiUrl + "gambar/kumulatif";
      this.$http.get(uri, this.config).then((response) => {
        this.errors = response.data.value;
      });
    },
    readImage() {
      this.upload = false;
      this.preview = true;
    },
    readImageMicroteaching() {
      this.uploadMicroteaching = false;
      this.previewMicroteaching = true;
    },
    cekData() {
      if (this.form.file_excel === "") {
        this.form.file_excel = "is-danger";
        this.form.file_excel = "Tidak Bisa Import";
        // count ++
      }
    },
    deleteDropFileMicroteaching() {
      //  this.form.picture.value = ''
      this.uploadMicroteaching = true;
      this.previewMicroteaching = false;
    },

    deleteDropFile() {
      //  this.form.picture.value = ''
      this.upload = true;
      this.preview = false;
    },
    postData() {
      var uri = this.$apiUrl + "import/" + this.detailId;
      var form = new FormData();
      this.isLoading = true;

      form.append("file_excel", this.file);
      if (this.cekData() == false) {
        this.snackbar("Gagal...Silahkan input lagi", "is-danger");
        this.file = null;
        this.isLoading = false;
        console.log(this.isLoading);
      } else {
        this.$http
          .post(uri, form, this.config)
          .then((response) => {
            this.isLoading = false;
            this.error_sekolah = response.data.error_sekolah;
            this.error_guru = response.data.error_guru;
            this.error_siswa = response.data.error_siswa;
            this.error_personil = response.data.error_personil;
            console.log(this.isLoading);
            // this.snackbarMsg = response.message
            this.snackbar("Data berhasil di Import!", "is-success");
            console.log(response.data.message);
            // console.log(response.data.message)
          })
          .catch((error) => {
            this.isLoading = false;
            console.log(this.isLoading);
            // console.log(error.response.data.message)
            this.errors = error;
            if (this.errors.message == "Request failed with status code 400") {
              this.snackbar(
                "Edit gagal. Sepertinya inputan salah...",
                "is-danger"
              );
            } else {
              this.snackbar(
                "Terjadi kesalahan..Silahkan input lagi",
                "is-danger"
              );
            }
          });
      }
      // this.isLoading = false
    },
    postDataMicro() {
      var uri = this.$apiUrl + "import/micro/" + this.detailId;
      var form = new FormData();
      this.isLoading = true;

      form.append("file_excel", this.file_microteaching);
      if (this.cekData() == false) {
        this.snackbar("Gagal...Silahkan input lagi", "is-danger");
        this.file_microteaching = null;
        this.isLoading = false;
        console.log(this.isLoading);
      } else {
        this.$http
          .post(uri, form, this.config)
          .then((response) => {
            this.isLoading = false;
            console.log(this.isLoading);
            this.snackbar("Data berhasil di Import!", "is-success");
            console.log(response.data.message);
          })
          .catch((error) => {
            this.isLoading = false;
            console.log(this.isLoading);
            this.errors = error;
            if (this.errors.message == "Request failed with status code 400") {
              this.snackbar(
                "Edit gagal. Sepertinya inputan salah...",
                "is-danger"
              );
            } else {
              this.snackbar(
                "Terjadi kesalahan..Silahkan input lagi",
                "is-danger"
              );
            }
          });
      }
    },
    snackbar(snackbarMessage, type) {
      this.$buefy.toast.open({
        duration: 5000,
        message: snackbarMessage,
        type: type,
        position: "is-top",
        actionText: "OK",
        queue: false,
      });
    },
  },
  watch: {
    picture: function (o) {
      var reader = new FileReader();
      reader.onload = (e) => this.$emit("load", e.target.result);
      reader.readAsText(o[0]);
      alert();
    },
  },
  mounted() {
    if (this.$session.exists()) {
      this.config = {
        headers: {
          Authorization: "Bearer " + this.$session.get("token"),
        },
      };
    }
    this.activeBiro = this.$session.get("biro");
    if (this.activeBiro) {
      this.detailId = this.activeBiro.id_biro;
      this.getBiro();
      // this.postData()
    }
  },
};
</script>
<style scoped>
table {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

td,
th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
}

tr:nth-child(even) {
  background-color: #dddddd;
}
</style>

